import { Text } from '@/hen-ui/atomics/Text';
import { Flex } from '@/hen-ui/composites/Flex';

import type { CareerExplorerRecommendationEnrollment as CareerExplorerRecommendationEnrollmentProps } from './types';

export const CareerExplorerRecommendationEnrollment = ({
  count,
  label,
}: CareerExplorerRecommendationEnrollmentProps) => (
  <Flex direction='row' gap='min' align='center' className='min-w-0'>
    <Text
      tag='span'
      variant='b4'
      weight='bold'
      className='text-left text-neutral-700'
    >
      {count}
    </Text>
    <Text tag='span' variant='b4' className='text-neutral-700'>
      {label}
    </Text>
  </Flex>
);
